export const SYSFIELDS_PREFIX = '$___'
export const SYSFIELDS_DROPZONE = SYSFIELDS_PREFIX + 'dropzone'
export const SYSFIELDS_DRAGGABLE = SYSFIELDS_PREFIX + 'draggable'
export const SYSFIELDS_RESIZABLE = SYSFIELDS_PREFIX + 'resizable'
export const SYSFIELDS_VALID = SYSFIELDS_PREFIX + 'valid'
export const SYSFIELDS_DIRTYCELLS = SYSFIELDS_PREFIX + 'dirtyCells'
export const SYSFIELDS_ANGELS = SYSFIELDS_PREFIX + 'angels'
export const SYSFIELDS_LOCKED = SYSFIELDS_PREFIX + 'locked'
export const SYSFIELDS_CHECKED = SYSFIELDS_PREFIX + 'checked'
export const SYSFIELDS_SIZE = SYSFIELDS_PREFIX + 'size'
export const SYSFIELDS_INDEX = SYSFIELDS_PREFIX + 'index'
export const SYSFIELDS_DISTANCE = SYSFIELDS_PREFIX + 'distance'
export const SYSFIELDS_ROWNUMBER = 'rowNumber'
export const SYSFIELDS_ROWSTATE = 'rowState'
export const SYSFIELDS_DISPLAYORDER = 'displayOrder'

export const ROW_NEW = 'new'
export const ROW_CHANGED = 'changed'
export const ROW_UNCHANGED = 'unchanged'
export const ROW_DELETED = 'deleted'
